import React, {useState, useEffect} from 'react'
import '../styles/_index.scss'
import {Link} from "react-router-dom"
import {message, Checkbox, Radio, Space, Button, Popconfirm, Tooltip} from "antd"
import { getDetailShippingCarrier, getCombinationBoxes, getShippingCarrier, saveChangeShippingCarrier, saveChangeCombinationBoxes, addNewCombinationBoxes, deleteCombinationBox } from '../../../services/api/apiSettingShippingCarrier'
import { getLocalData } from '../../../services/StorageServices'
import {WarningOutlined} from '@ant-design/icons'

function SettingShippingBox(props) {
    const [shippingCarrier, setShippingCarrier] = useState({})
    const [combinationBoxes, setCombinationBoxes] = useState([])
    const [optionsShippingCarrier, setOptionsShippingCarrier] = useState([])
    const [shippingBox, setShippingBox] = useState('')
    const [activeBoxOption, setActiveBoxOption] = useState('')
    const [combinationBoxNameBefore, setCombinationBoxNameBefore] = useState('')
    const [combinationBoxName, setCombinationBoxName] = useState('')
    const [selectedShippingCarrierBefore, setSelectedShippingCarrierBefore] = useState([])
    const [selectedShippingCarrier, setSelectedShippingCarrier] = useState([])
    const [selectedCombinationBoxesBefore, setSelectedCombinationBoxesBefore] = useState('')
    const [selectedCombinationBoxes, setSelectedCombinationBoxes] = useState('')
    const [validate, setValidate] = useState({})

    async function fetchDetailShippingCarrier() {
        try {
            const {match} = props
            const {shipping_carrier_id} = match.params

            const {data: response} = await getDetailShippingCarrier(shipping_carrier_id)
            const {success, message: error, data} = response

            if (!success) {
                setShippingCarrier({})
                setShippingBox('')
                return message.error(error)
            }

            setShippingCarrier(data)
            setShippingBox(data.box_name)
        } catch (e) {
            message.error(e.message)
        }
    }

    async function fetchCombinationBoxes() {
        
        try {
            const payload = {
                limit: 1000,
                page: 1
            }
            const {data, success, message: errMsg} = await getCombinationBoxes(payload)

            if (!success) {
                setCombinationBoxes([])
                setSelectedCombinationBoxes('')
                setSelectedCombinationBoxesBefore('')
                return message.error(errMsg)
            }

            const {boxes} = data
            const shippingCarrierHaveBox = boxes.filter(box => box.shipping_carriers.includes(shippingCarrier.slug))
            
            if(shippingCarrierHaveBox.length === 1){
                setSelectedCombinationBoxes(shippingCarrierHaveBox[0]._id)
                setSelectedCombinationBoxesBefore(shippingCarrierHaveBox[0]._id)
                setCombinationBoxName(shippingCarrierHaveBox[0].box_name)
                setCombinationBoxNameBefore(shippingCarrierHaveBox[0].box_name)
                const otherShippingCarriers = shippingCarrierHaveBox[0].shipping_carriers.filter(item => item !== shippingCarrier.slug)
                
                if(otherShippingCarriers.length > 0){
                    setSelectedShippingCarrier(otherShippingCarriers)
                    setSelectedShippingCarrierBefore(otherShippingCarriers)
                }
            }
            setCombinationBoxes(boxes)
        } catch (e) {
            message.error(e.message)
        }
    }

    const fetchListOptionCarrier = async () => {

        try {
            const {match} = props
            const {shipping_carrier_id} = match.params

            const payload = {
                page: 1,
                limit: 500
            }
            const {data, success, massage} = await getShippingCarrier(payload)
            
            if (!success) {
                setOptionsShippingCarrier([])
                return message.error(massage)
            }

            const listOptions = data.shippingCarriers.filter(shippingCarrier => shippingCarrier._id !== shipping_carrier_id).map(shippingCarrier => {
                return {
                    label: shippingCarrier.name,
                    value: shippingCarrier.slug
                }
            })
            
            setOptionsShippingCarrier(listOptions)
        } catch (e) {
            message.error(e.message)
        }
    }

    useEffect(() => {
        fetchDetailShippingCarrier()
        // fetchCombinationBoxes()
        // fetchListOptionCarrier()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        // fetchDetailShippingCarrier()
        fetchCombinationBoxes()
        fetchListOptionCarrier()
        // eslint-disable-next-line
    }, [shippingCarrier])

    const reloadPage = () => {
        fetchDetailShippingCarrier()
        fetchCombinationBoxes()
        fetchListOptionCarrier()
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target

        if(name === 'shippingBox'){
            setShippingBox(value)
            const validateClone = {...validate}
            delete validateClone.shippingBox
            setValidate(validateClone)
        }else if(name === 'combinationBoxName'){
            setCombinationBoxName(value)
            const validateClone = {...validate}
            delete validateClone.combinationBoxName
            delete validateClone.combinationBoxNameExist
            setValidate(validateClone)
        }
    }

    const onChangeShippingCarrier = (checkedValues) => {
        setSelectedShippingCarrier(checkedValues)
        const validateClone = {...validate}
        delete validateClone.selectedShippingCarrier
        setValidate(validateClone)
    };

    const onChangeCombinationBoxes = (e) => {
        setSelectedCombinationBoxes(e.target.value)
    };

    const  _handleResetChange = () => {
        setValidate({})
        setShippingBox(shippingCarrier.box_name)

        const shippingCarrierHaveBox = combinationBoxes.filter(box => box.shipping_carriers.includes(shippingCarrier.slug))
        if(shippingCarrierHaveBox.length > 0){
            setCombinationBoxName(combinationBoxNameBefore)
            setSelectedShippingCarrier(selectedShippingCarrierBefore)
        }else{
            setActiveBoxOption('')
            setCombinationBoxName('')
            setSelectedShippingCarrier([])
            setSelectedCombinationBoxes('')
        }
    }

    const _handleValidate = () => {
        const validate = {}
        let flag = true

        if(shippingBox === '' || shippingBox.length > 100 || !/^[A-Za-z0-9_]+$/.test(shippingBox)) validate.shippingBox ='Tên của thùng phải là một chuỗi ký tự có độ dài không quá 100 ký tự, không rỗng và chỉ chứa chữ cái (in hoa và in thường), chữ số hoặc dấu gạch dưới.'

        const shippingCarrierHaveBox = combinationBoxes.filter(box => box.shipping_carriers.includes(shippingCarrier.slug))
        if(shippingCarrierHaveBox.length > 0){
            const combinationBoxesOther = combinationBoxes.filter(box => !box.shipping_carriers.includes(shippingCarrier.slug))
            const combinationBoxNameExist = combinationBoxesOther.filter(box => box.box_name === combinationBoxName)
            if(combinationBoxName === '' || combinationBoxName.length > 100 || !/^[A-Za-z0-9_]+$/.test(combinationBoxName)) validate.combinationBoxName ='Tên của thùng phải là một chuỗi ký tự có độ dài không quá 100 ký tự, không rỗng và chỉ chứa chữ cái (in hoa và in thường), chữ số hoặc dấu gạch dưới.'
            if(combinationBoxNameExist.length > 0) validate.combinationBoxNameExist = 'Thùng đã tồn tại.'
            if(selectedShippingCarrier.length === 0) validate.selectedShippingCarrier = 'Phải chọn ít nhất 1 shipping carrier thêm vào thùng gộp.'
        }else{
            if(combinationBoxName || selectedShippingCarrier.length > 0){
                const combinationBoxNameExist = combinationBoxes.filter(box => box.box_name === combinationBoxName)
                if(combinationBoxName === '' || combinationBoxName.length > 100 || !/^[A-Za-z0-9_]+$/.test(combinationBoxName)) validate.combinationBoxName = 'Tên của thùng phải là một chuỗi ký tự có độ dài không quá 100 ký tự, không rỗng và chỉ chứa chữ cái (in hoa và in thường), chữ số hoặc dấu gạch dưới.'
                if(combinationBoxNameExist.length > 0) validate.combinationBoxNameExist = 'Thùng đã tồn tại.'
                if(selectedShippingCarrier.length === 0) validate.selectedShippingCarrier = 'Phải chọn ít nhất 1 shipping carrier thêm vào thùng gộp.'
            }
            // if(activeBoxOption === 'combinationBox' && selectedCombinationBoxes.length === 0) validate.selectedCombinationBoxes = 'Phải chọn 1 thùng gộp.'
        }

        setValidate(validate)

        if (Object.keys(validate).length > 0) return flag = false
        return flag
    }

    const _saveUpdateInfoShippingCarrier = async () => {

        if(shippingBox === shippingCarrier.box_name) return

        const payload = {
            box_name: shippingBox ? shippingBox : ''
        }

        const response = await saveChangeShippingCarrier(shippingCarrier._id, payload)
        return response
    }

    const _saveUpdateCombinationBoxes = async () => {

        if(combinationBoxName === combinationBoxNameBefore && JSON.stringify(selectedShippingCarrier) === JSON.stringify(selectedShippingCarrierBefore) && selectedCombinationBoxes === selectedCombinationBoxesBefore) return

        const shippingCarrierHaveBox = combinationBoxes.filter(box => box.shipping_carriers.includes(shippingCarrier.slug))

        const payload = {}
        if(shippingCarrierHaveBox.length > 0){
            const shippingCarriersNew = [...selectedShippingCarrier]
            shippingCarriersNew.push(shippingCarrier.slug)
            payload.box_name = combinationBoxName
            payload.shipping_carriers = shippingCarriersNew
        }else{
            const selectedCombinationBox = combinationBoxes.filter(box => box._id === selectedCombinationBoxes)
            const shippingCarriersNew = [...selectedCombinationBox[0].shipping_carriers]
            shippingCarriersNew.push(shippingCarrier.slug)
            payload.box_name = selectedCombinationBox[0].box_name
            payload.shipping_carriers = shippingCarriersNew
        }

        const response = await saveChangeCombinationBoxes(selectedCombinationBoxes, payload)
        return response;
    }

    const _addNewCombinationBoxes = async () => {

        if(activeBoxOption === '' || ((activeBoxOption === 'shippingCarrier' && !combinationBoxName && selectedShippingCarrier.length === 0) || (activeBoxOption === 'combinationBox' && !selectedCombinationBoxes))) return

        const payload = {}
        if(activeBoxOption === 'shippingCarrier'){
            const shippingCarriersNew = [...selectedShippingCarrier]
            shippingCarriersNew.push(shippingCarrier.slug)
            payload.box_name = combinationBoxName
            payload.shipping_carriers = shippingCarriersNew
        }else{
            const selectedCombinationBox = combinationBoxes.filter(box => box._id === selectedCombinationBoxes)
            const shippingCarriersNew = [...selectedCombinationBox[0].shipping_carriers]
            shippingCarriersNew.push(shippingCarrier.slug)
            payload.box_name = selectedCombinationBox[0].box_name
            payload.shipping_carriers = shippingCarriersNew
        }

        const response  = await addNewCombinationBoxes(payload)
        return response
    }

    const _handleSaveChangeNew = async () => {

        if(!_handleValidate()) return

        _saveUpdateInfoShippingCarrier()
        .then(result => {
            if(result === undefined){
                _saveUpdateCombinationBoxes()
            }else{
                const {success, message} = result
                if(success){
                    _saveUpdateCombinationBoxes()
                }else{
                    throw message
                }
            }
        }).then(result2 =>  {
            if(result2 === undefined){
                message.success('Update success!')
                reloadPage()
            }else{
                const {success, message} = result2
                if(success){
                    message.success('Update success!')
                    reloadPage()
                }else{
                    throw message
                }
            }
        }).catch(err => {
            message.error(err)
        })
    }

    const _handleSaveChangeNoBoxesNew = async () => {

        if(!_handleValidate()) return

        _saveUpdateInfoShippingCarrier()
        .then(result => {
            if(result === undefined){
                _addNewCombinationBoxes()
            }else{
                const {success, message} = result
                if(success){
                    _addNewCombinationBoxes()
                }else{
                    throw message
                }
            }
        }).then(result2 =>  {
            if(result2 === undefined){
                message.success('Update success!')
                reloadPage()
            }else{
                const {success, message} = result2
                if(success){
                    message.success('Update success!')
                    reloadPage()
                }else{
                    throw message
                }
            }
        }).catch(err => {
            console.log('err', err)
            message.error(err)
        })
    }

    const _handleSelectBoxOption = (boxOption) => {
        setActiveBoxOption(boxOption)
        if(boxOption === 'shippingCarrier'){
            setSelectedCombinationBoxes('')
        }else{
            setCombinationBoxName('')
            setSelectedShippingCarrier([])
            const validateClone = {...validate}
            delete validateClone.combinationBoxName
            delete validateClone.selectedShippingCarrier
            setValidate(validateClone)
        }
    }

    const _handleRemoveShippingCarrierFromBox = async () => {
        try {
            const selectedBoxObj = combinationBoxes.filter(box => box._id === selectedCombinationBoxes)
            const shippingCarriersNew = selectedBoxObj[0].shipping_carriers.filter(item => item !== shippingCarrier.slug)
            
            const payload = {
                box_name: selectedBoxObj[0].box_name,
                shipping_carriers: shippingCarriersNew
            }

            const {success, message: messUpdate} = await saveChangeCombinationBoxes(selectedCombinationBoxes, payload)
            
            if (!success) {
                return message.error(messUpdate);
            }

            setActiveBoxOption('')
            setCombinationBoxName('')
            setCombinationBoxNameBefore('')
            setSelectedShippingCarrier([])
            setSelectedShippingCarrierBefore([])
            setSelectedCombinationBoxes('')
            setSelectedCombinationBoxesBefore('')
            reloadPage()
        } catch (e) {
            message.error(e.message)
        }
    }

    const _handleDeleteCombinationBox = async () => {
        try {

            const {success, message: messUpdate} = await deleteCombinationBox(selectedCombinationBoxes)
            
            if (!success) {
                return message.error(messUpdate);
            }

            setCombinationBoxName('')
            setSelectedShippingCarrier([])
            setSelectedCombinationBoxes('')
            reloadPage()
        } catch (e) {
            message.error(e.message)
        }
    }

    const shippingCarrierHaveBox = combinationBoxes.filter(box => box.shipping_carriers.includes(shippingCarrier.slug))
    const shippingBoxClass = shippingCarrierHaveBox.length > 0 ? 'card boxOption shippingCarrierOption mr-2 active' : activeBoxOption && activeBoxOption === 'shippingCarrier' ? 'card boxOption shippingCarrierOption mr-2 active' : 'card boxOption shippingCarrierOption mr-2'
    const combinationBoxClass = shippingCarrierHaveBox.length > 0 ?'card boxOption combinationBoxOption ml-2 disable' : activeBoxOption && activeBoxOption === 'combinationBox' ? 'card boxOption combinationBoxOption ml-2 active' : 'card boxOption combinationBoxOption ml-2'

    const disableButton = shippingBox !== shippingCarrier.box_name || combinationBoxName !== combinationBoxNameBefore || JSON.stringify(selectedShippingCarrier) !== JSON.stringify(selectedShippingCarrierBefore) || selectedCombinationBoxes !== selectedCombinationBoxesBefore ? false : true

    const _renderTitleConfirm = () => {
        return (
            <>
                Are you sure want to remove shipping carrier ({shippingCarrier.name}) from this combination box ({shippingCarrier.combination_box && shippingCarrier.combination_box.box_name ? shippingCarrier.combination_box.box_name : '' })?
            </>
        )
    }

    const _renderTitleConfirmDelete = () => {
        return (
            <>
                Are you sure want to delete this combination box ({shippingCarrier.combination_box && shippingCarrier.combination_box.box_name ? shippingCarrier.combination_box.box_name : '' })?
            </>
        )
    }

    const shippingCarrierExclude = combinationBoxes.filter(box => !box.shipping_carriers.includes(shippingCarrier.slug)).map(box => {
        return box.shipping_carriers
    })

    const optionsShippingCarrierNoBoxes = optionsShippingCarrier.filter(option => !shippingCarrierExclude.flat().includes(option.value))

    const userRoles = !!getLocalData('roles') && getLocalData('roles').length > 0 ? getLocalData('roles').map(i => i.name) : []
    const adminPermission = !!userRoles.length && userRoles.includes('fac_admin')

    return (
        <div className="shippingBoxesContainer">
            <div className="BackWrapper">
                <Link to='/shipping-carrier'><i className='fa fa-chevron-left'/>Shipping Carrier Management</Link>
            </div>

            <div className="TitlePage d-flex justify-content-between align-items-center">
                <h1>Shipping Boxes</h1>

                <div className='action'>
                    <Button className='btn-secondary ml-3' onClick={_handleResetChange} disabled={disableButton}>
                        Cancel
                    </Button>

                    <Button className='btn-primary ml-3' onClick={() => shippingCarrierHaveBox.length > 0 ? _handleSaveChangeNew() : activeBoxOption === 'combinationBox' ? _handleSaveChangeNew() : _handleSaveChangeNoBoxesNew()} disabled={disableButton}>
                        Save
                    </Button>
                </div>
            </div>

            <div className="card settingShippingBoxes">
                <div className="card-body">
                    <div className="formShippingBoxes">
                        <div className="itemInfo mb-3 d-flex align-items-center">
                            <label className="itemLabel col-form-label font-weight-bold" style={{width: 120}}>Slug</label>
                            <div className="itemValue">
                                <input
                                    name="slug"
                                    className="ant-input"
                                    // onChange={_handleChangeInput}
                                    value={shippingCarrier.slug || ''}
                                    disabled={true}
                                    style={{width: 350}}
                                />
                            </div>
                        </div>

                        <div className="itemInfo mb-3 d-flex align-items-center">
                            <label className="itemLabel col-form-label font-weight-bold" style={{width: 120}}>Shipping carrier</label>
                            <div className="itemValue">
                                <input
                                    name="shippingCarrier"
                                    className="ant-input"
                                    // onChange={_handleChangeInput}
                                    value={shippingCarrier.name || ''}
                                    disabled={true}
                                    style={{width: 350}}
                                />
                            </div>
                        </div>

                        <div className="itemInfo mb-3 d-flex align-items-center">
                            <label className="itemLabel col-form-label font-weight-bold" style={{width: 120}}>Shipping box</label>
                            <div className="itemValue">
                                <input
                                    name="shippingBox"
                                    className="ant-input"
                                    onChange={_handleChangeInput}
                                    value={shippingBox || ''}
                                    style={{width: 350}}
                                />
                            </div>
                        </div>

                        {!!validate.shippingBox && (
                            <div className="text-danger mb-2">{validate.shippingBox}</div>
                        )}

                        <div className="itemInfo mb-3 d-flex align-items-cente flex-column">
                            <label className="itemLabel col-form-label font-weight-bold">Combine carriers/shipping box:</label>
                            <div className="itemValue d-flex">
                                <div className={shippingBoxClass} style={{width: '50%'}} onClick={() => shippingCarrierHaveBox.length > 0 ? '' : _handleSelectBoxOption('shippingCarrier')}>
                                {/* <div className={shippingBoxClass} style={{width: '50%'}}> */}
                                    <div className='card-body'>
                                        <label className='font-weight-bold' style={{width: '100%', textAlign: 'center'}}>SHIPPING CARRIERS</label>
                                        {
                                            shippingCarrierHaveBox.length > 0 ?   <Popconfirm
                                            title={_renderTitleConfirm}
                                            description="Are you sure to delete this task?"
                                            onConfirm={_handleRemoveShippingCarrierFromBox}
                                            // onCancel={cancel}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button className='btn-danger mb-3'>
                                                Remove shipping carrier from this combination box
                                            </Button>
                                        </Popconfirm> : ''
                                        }
                                        
                                        <div className='combinationName mb-3 d-flex align-items-center'>
                                            <label className="itemLabel col-form-label font-weight-bold" style={{width: 200}}>Combination box name:</label>
                                            <div className="itemValue">
                                                <input
                                                    name="combinationBoxName"
                                                    className="ant-input"
                                                    onChange={_handleChangeInput}
                                                    value={combinationBoxName || ''}
                                                    style={{width: 350}}
                                                />

                                            {
                                                shippingCarrierHaveBox.length > 0 ? adminPermission ? <Popconfirm
                                                title={_renderTitleConfirmDelete}
                                                onConfirm={_handleDeleteCombinationBox}
                                                // onCancel={cancel}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <Tooltip title="Delete combination box">
                                                    <i className="fa fa-trash fa-lg text-danger ml-3" style={{fontSize: 30}}/>
                                                </Tooltip>
                                            </Popconfirm> : <Popconfirm
                                                title="You do not have permission to delete combination box!"
                                                onConfirm=""
                                                icon={<WarningOutlined />}
                                                okButtonProps={{ style: { display: 'none' } }}
                                                cancelText="Cancel"
                                            >
                                                <Tooltip title="Delete combination box">
                                                    <i className="fa fa-trash fa-lg text-danger ml-3" style={{fontSize: 30}}/>
                                                </Tooltip>
                                            </Popconfirm> : ''
                                            }
                                            </div>
                                        </div>

                                        {!!validate.combinationBoxName && (
                                            <div className="text-danger mb-2">{validate.combinationBoxName}</div>
                                        )}

                                        {!!validate.combinationBoxNameExist && (
                                            <div className="text-danger mb-2">{validate.combinationBoxNameExist}</div>
                                        )}

                                        <div className='shippingCarrierCheckbox'>
                                            <Checkbox.Group options={optionsShippingCarrierNoBoxes} onChange={onChangeShippingCarrier} value={selectedShippingCarrier || []}/>
                                            {/* <Checkbox.Group onChange={onChangeShippingCarrier} value={selectedShippingCarrier || []}>
                                                {
                                                    optionsShippingCarrier.length > 0 && optionsShippingCarrier.map(option => {
                                                        const disable = _handleDisableCheckbox(option.value)
                                                        console.log('disable: ', disable)
                                                        return <Checkbox value={option.value}>{option.label}</Checkbox>
                                                    })
                                                }
                                                
                                            </Checkbox.Group> */}
                                        </div>

                                        {!!validate.selectedShippingCarrier && (
                                            <div className="text-danger mb-2">{validate.selectedShippingCarrier}</div>
                                        )}
                                    </div>
                                </div>
                                
                                <div className={combinationBoxClass} style={{width: '50%'}} onClick={() => selectedCombinationBoxes.length > 0 ? '' : _handleSelectBoxOption('combinationBox')}>
                                {/* <div className={combinationBoxClass} style={{width: '50%'}}> */}
                                    <div className='card-body'>
                                        <label className='font-weight-bold' style={{width: '100%', textAlign: 'center'}}>COMBINATION BOXES</label>

                                        <div className='combinationBoxs'>
                                            <Radio.Group onChange={onChangeCombinationBoxes} value={selectedCombinationBoxes}>
                                                <Space direction="vertical">
                                                    {
                                                        combinationBoxes.map((combinationBox, index) => {
                                                            const boxLabel = combinationBox.shipping_carrier_names.join(", ")
                                                            return <Radio value={combinationBox._id} key={index}><label style={{fontWeight: 'bold', marginRight: 4}}>{combinationBox.box_name}: </label>{boxLabel}</Radio>
                                                        })
                                                    }
                                                </Space>
                                            </Radio.Group>
                                        </div>
                                    </div>
                                    
                                    {!!validate.selectedCombinationBoxes && (
                                            <div className="text-danger mb-2">{validate.selectedCombinationBoxes}</div>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default SettingShippingBox
